import { createActions } from 'reduxsauce';

var _createActions = createActions({
  pageChange: function pageChange(json) {
    return {
      type: 'ARTICLE_PAGE_CHANGE',
      currentPage: json.currentPage
    };
  },
  yearChange: function yearChange(json) {
    return {
      type: 'ARTICLE_YEAR_CHANGE',
      filterYear: json.filterYear,
      currentPage: 1
    };
  },
  pageSizeChange: function pageSizeChange(json) {
    return {
      type: 'ARTICLE_PAGE_SIZE_CHANGE',
      pageSize: json.pageSize
    };
  },
  sourceChange: function sourceChange(json) {
    return {
      type: 'ARTICLE_SOURCE_CHANGE',
      dataSource: json.dataSource
    };
  },
  request: function request() {
    return {
      type: 'ARTICLE_REQUEST'
    };
  },
  response: function response(json) {
    return {
      type: 'ARTICLE_RESPONSE',
      articleResults: json.Items,
      totalArticles: json.TotalResults,
      facets: json.Facets
    };
  }
}, {
  prefix: 'ARTICLE_'
}),
    Creators = _createActions.Creators,
    Types = _createActions.Types;

export default {
  Creators: Creators,
  Types: Types
};